export default __webpack_public_path__ + "static/safetynet-f6bd6a307470915332a7f60af22e868e.png";